// SHER-273: the smartfield list table (SmartFields/index.tsx) is shared by
// treatments AND non-treatment list fields (allergy, background, ...). The
// remove-confirmation modal used to hardcode treatment wording ("Remove
// Treatment" / "Reason for discontinuation") for every type, so deleting an
// allergy showed a treatment discontinuation modal.
//
// A deletion reason is still required for every type (the API enforces it for
// audit), so this only swaps the *copy*: treatment fields keep their wording,
// every other smartfield gets generic "remove entry / reason for removal" copy.

export interface RemoveModalCopyKeys {
    title: string;
    motive: string;
    placeholder: string;
    required: string;
}

const TREATMENT_KEYS: RemoveModalCopyKeys = {
    title: 'hospital.treatment-remove-title',
    motive: 'hospital.treatment-remove-motive',
    placeholder: 'hospital.treatment-remove-placeholder',
    required: 'hospital.treatment-remove-required',
};

const RECORD_KEYS: RemoveModalCopyKeys = {
    title: 'hospital.record-remove-title',
    motive: 'hospital.record-remove-motive',
    placeholder: 'hospital.record-remove-placeholder',
    required: 'hospital.record-remove-required',
};

/**
 * Returns the i18n keys for the remove-confirmation modal based on the
 * smartfield type. Treatment types (treatment, treatment_regular,
 * treatment_inpatient) keep the treatment-specific wording; every other type
 * (allergy, background, family-background, ...) uses generic record wording.
 */
export function removeModalCopyKeys(type?: string): RemoveModalCopyKeys {
    const isTreatment = typeof type === 'string' && type.startsWith('treatment');
    return isTreatment ? TREATMENT_KEYS : RECORD_KEYS;
}
